import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';

import { RouterOutlet, RouterLink } from '@angular/router';
import { APP_NAME } from '../../utils';
@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: true,
  imports: [RouterOutlet, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthComponent implements OnInit, OnDestroy {
  today: Date = new Date();
  appName = inject(APP_NAME);
  constructor() { }

  ngOnInit(): void { }

  ngOnDestroy() { }
}
